var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('h2',[_vm._v("\n    To begin, choose the type of financing you are seeking:\n  ")]),_c('DealTypeGrid',{on:{"continue":_vm.nextStep}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }